<h3 class="group-bordered__subtitle"><ng-content select="h3"></ng-content></h3>
<div class="group-bordered">
    <h2 class="group-bordered__title"><ng-content select="h2"></ng-content></h2>
    <h4 class="group-bordered__subtitle"><ng-content select="h4"></ng-content></h4>
    <ng-content select=".group-bordered-inner"></ng-content>
</div>
